const PilotRanks = [
  'Top Ace',
  'Junior Ace',
  'Veteran',
  'Regular',
  'Sprog',
];
export default PilotRanks;
